module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "video-overlay"
    },
    on: {
      "click": _vm.toggleVideo
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "video"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fba0cec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video.vue
// module id = 441
// module chunks = 2